import React, { useEffect, useState } from "react";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";
import { useNavigate } from "react-router-dom";

import { useForm, Controller } from "react-hook-form";
import Select from "react-select";
import Topbar from "../../../Component/Topbar/Topbar";
import { Table } from "../../../Component/Table/Table";
import { edit, search, view } from "../../../assets/img";
import DateRange from "../../../Component/DateRange/DateRange";
import SelectBox from "../../../Component/SelectBox";
import { get, post } from "../../redux/api/ApiHandler";
import { URLS } from "../../redux/api/Constants";
import moment from "moment";
import Technical from "../../HO/Technical/Technical";
import useSearchFunction from "../../../Component/searchFunction";
const DispatchTable = () => {
  const navigate = useNavigate();

  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [superAdmin, setSuperAdmin] = useState();
  const [pagination, setPagination] = useState("");
  const [selected, setSelected] = useState(null);
  const [status, setStatus] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [regionOptions, setRegionOptions] = useState([]);
  const [fromDates, setFromDates] = useState(null);
  const [toDates, setToDates] = useState(null);

  const role = localStorage.getItem("role");

  const debounceval = useSearchFunction(searchValue);

  const ticketList = async (search, selected, fromDate, toDate) => {
    setSearchValue(search);
    setFromDates(fromDate);
    setToDates(toDate);
    setSelected(selected);

    let payload = {
      search: search,
      // page: page,
      region_id: selected?.value,
      type: 2,
      current_status: role == "Inventory" ? 9 : role == "Technical" ? 13 : "",
      from_date: fromDate ? moment(fromDate).format("DD-MM-YYYY") : "",
      to_date: toDate ? moment(toDate).format("DD-MM-YYYY") : "",
    };
    let res = await post(URLS.TICKET_LIST, payload);
    if (res?.status == "success") {
      // let array = [4, 9, 10];
      // let arr = res?.lists.filter(item => array.includes(item?.current_status))
      let mappedData = res?.lists?.map((item) => {
        let obj = { ...item };
        obj.trackin_id = [...item?.ticket_details]
          ?.reverse()
          ?.find((i) => i.tracking)?.tracking?.tracking_no;
        return obj;
      });
      console.log("mappedDatum", mappedData);
      setList(mappedData);
      // setList(res?.lists);
      setPagination(res?.pagination_meta);
    }
  };

  const regionList = async () => {
    let res = await get(URLS.REGIONLIST);
    if (res?.status === "success" && Array.isArray(res?.roles)) {
      // 🔹 Convert API data to Select options
      const options = res?.roles.map((region) => ({
        value: region?.id,
        label: region?.name,
      }));
      setRegionOptions(options);
    }
  };

  useEffect(() => {
    ticketList(debounceval);
    regionList();
  }, [debounceval]);

  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p>{(page - 1) * 10 + row.index + 1}</p>;
        },
      },

      {
        Header: "Regional Ticket ID ",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Region",
        accessor: "region",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Regional Manager",
        accessor: "regional_manager",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Service Engineer",
        accessor: "service_engineer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },

      {
        Header: "Customer ID",
        accessor: "customer.code",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Customer Name",
        accessor: "customer",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value?.name}</p>;
        },
      },
      {
        Header: "Created by",
        accessor: "created_by.name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },

      {
        Header: "Date",
        accessor: "opened_at",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">{moment(value).format("DD-MM-YYYY")}</p>
          );
        },
      },
      // {
      //   Header: role == "Inventory" ? "Tracking ID" : "Fault Type",
      //   accessor: "trackin_id",
      //   Cell: ({ value, row }) => {
      //     return <p className="text-nowrap d-flex ac-jc">{value ? value : '-'}</p>;
      //   },
      // },
      {
        Header: "Request Status",
        accessor: "current_status",
        Cell: ({ value, row }) => {
          return (
            <div className="d-flex ac-jc">
              {/* {role == "Inventory" ? (
                <button
                  // onClick={() => handleStatus(row)}
                  className="Yet_To_Start     f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16"
                >
                  Dispatched
                </button>
              ) : (
                <button
                  // onClick={() => handleStatus(row)}
                  className="Yet_To_Start     f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16"
                  style={{ backgroundColor: "#FFD035" }}
                >
                  Inventory
                </button>
              )} */}
              {role == "Technical" && (
                <button
                  // onClick={() => handleStatus(row)}
                  className={`${
                    value == 5
                      ? "technical_btn"
                      : value == 3
                      ? "inventory_button"
                      : value == 7
                      ? "dispatched_btn"
                      : "yet_to_start_btn"
                  } f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16`}
                >
                  {value === 13
                    ? "Technical"
                    : value === 3
                    ? "Inventory"
                    : value === 7
                    ? "Next Visit"
                    : value === 9
                    ? "Senior Support"
                    : value === 14
                    ? "Super Admin"
                    : ""}
                </button>
              )}
              {role == "Inventory" && (
                <button
                  // onClick={() => handleStatus(row)}
                  className={`${
                    value == 5
                      ? "technical_btn"
                      : value == 3
                      ? "inventory_button"
                      : value == 7
                      ? "dispatched_btn"
                      : "yet_to_start_btn"
                  } f1 fs-xs-12 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-15 fs-xxl-16`}
                >
                  {value === 13
                    ? "Technical"
                    : value === 3
                    ? "Inventory"
                    : value === 10
                    ? "Inventory Delivered"
                    : value === 9
                    ? "Inventory Dispatched"
                    : value === 14
                    ? "Super Admin"
                    : ""}
                </button>
              )}
            </div>
          );
        },
      },
      {
        Header: "Actions",
        accessor: "",
        Cell: ({ value, row }) => {
          const status = row.original.status;
          return (
            <div className="d-flex ac-jc mt-2 gap-3">
              <button
                onClick={() => {
                  navigate(
                    "/view-dispatch",
                    {
                      state: {
                        type: "view",
                        id: row?.original?.id,
                        tickType: "Dispatch",
                        detail: role != "Technical" ? "Inventory" : "Technical",
                      },
                    }
                    //   {
                    //   state: {
                    //     type: "view",
                    //     data: {
                    //       ticketType: "Dispatch",
                    //       trackingId: "ICIPL234",
                    //     },
                    //   },
                    // }
                  );
                }}
                className="cust-btn "
              >
                <img src={view} alt="" className="editor-btn" />
              </button>
              {role != "Technical" && (
                <button
                  onClick={() => {
                    navigate("/view-dispatch", {
                      state: {
                        type: "edit",
                        id: row?.original?.id,
                        tickType: "Dispatch",
                        detail: role != "Technical" ? "Inventory" : "Technical",
                      },
                    });
                  }}
                  className="cust-btn "
                >
                  <img src={edit} alt="" className="editor-btn" />
                </button>
              )}
            </div>
          );
        },
      },
    ],
    []
  );
  return (
    <>
      <Topbar header={role == "Technical" ? "Issue Resolved" : "Dispatch"} />
      <div className="container_fluit1">
        <div className="d-flex ac-js">
          <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24">
            Total New Ticket : {list?.length}
          </h4>
        </div>
        <div className="d-flex ac-je gap-4">
          <DateRange
            fromDate={fromDates}
            setFromDate={(val) =>
              ticketList(searchValue, selected, val, toDates)
            }
            toDate={toDates}
            setToDate={(val) =>
              ticketList(searchValue, selected, fromDates, val)
            }
          />
          <div className="col-md-2">
            <SelectBox
              options={regionOptions}
              selected={selected}
              setSelected={(val) =>
                ticketList(searchValue, val, fromDates, toDates)
              }
            />
          </div>

          <div className="search-input col-md-3 d-flex ac-jb my-4">
            <input
              value={searchValue}
              onChange={(val) =>
                setSearchValue(val.target.value, selected, fromDates, toDates)
              }
              type="text"
              placeholder="Search "
              className="search-field f2 fs-sm-13 fs-md-15 fs-lg-16 fs-xl-18 fs-xxl-20"
            />
            <img src={search} className="search" />
          </div>
        </div>
        <Table
          columns={columns}
          setPageno={setPage}
          // pagecount={pagination}
          data={list ?? []}
          show={true}
        />
      </div>
    </>
  );
};

export default DispatchTable;
